import grid from './grid.js'
import polar from './polar.js'
import column from './column.js'
import torus from './torus.js'
import particles from './particles.js'

export const substrates = { grid, polar, column, torus, particles }
export const substrateOptions = Object.values(substrates).map((s) => ({ value: s.id, label: s.label }))
